/** True when url targets loopback (localhost / 127.0.0.1). Triggers Chrome "Apps on device" from public HTTPS sites. */
export function isLoopbackUrl(url: string): boolean {
  if (!url || url.startsWith('/')) return false;
  try {
    const { hostname } = new URL(url);
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
  } catch {
    return false;
  }
}

/** Use same-origin /api when a public page would otherwise fetch loopback (misbuilt bundle safety net). */
export function apiBaseForBrowser(configuredBase: string): string {
  const base = configuredBase.replace(/\/+$/, '') || '/api';
  if (typeof window === 'undefined') return base;
  if (window.location.protocol === 'https:' && isLoopbackUrl(base)) {
    return '/api';
  }
  return base;
}
